import {config } from '../config';
import { getUserToken } from '../service/UserService';

export function getAllItems(){
    let url = config.API_URL + '/Item/getAll.php';
    //console.log("calling url:" + url);
    return fetch(url)
        .then(response => response.json())
        .then(data => {
            //this.setState({ postId: data.id })
            //console.log("all items:", data);
            return data;
        });
}
export function getActiveItems(){
        let url = config.API_URL + '/Item/getActive.php';
        //console.log("calling url:" + url);
        return fetch(url)
            .then(response => response.json())
            .then(data => {
                //this.setState({ postId: data.id })
                //console.log("active:", data);
                return data;
            });
}

export function getRegistrations(){
    let url = config.API_URL + '/Item/getRegistrations.php?token=' + getUserToken();
        //console.log("calling url:" + url);
        return fetch(url)
            .then(response => response.json())
            .then(data => {
                //this.setState({ postId: data.id })
                //console.log("registrations:", data);
                return data;
            });
}